export const SITE = {
    appName: "Kinora OS",
    tagline: "Your family's central operating system.",
    company: "EmberCore Digital (Pty) Ltd",
    address: "4 Yellowwood Road, Glen Anil, Durban, 4051, South Africa",
    supportEmail: "support@embercoredigital.co.za",
    infoOfficerEmail: "info.officer@embercoredigital.co.za",
    logo: "https://customer-assets.emergentagent.com/job_kinora-organize/artifacts/sjbboigi_KinoraOS%20APP%20Icon.png",
    effectiveDate: "1 December 2025",
};

export const IMAGES = {
    heroFamily:
        "https://customer-assets.emergentagent.com/job_kinora-organize/artifacts/dft4xcl3_KinoraOS%20Image%20-%20Background%20picture.png",
    securityAbstract:
        "https://images.unsplash.com/photo-1768720407298-1b24a0f6749d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxzZWN1cmUlMjBkaWdpdGFsJTIwdmF1bHQlMjBibHVlfGVufDB8fHx8MTc4MzM3NTU0M3ww&ixlib=rb-4.1.0&q=85",
};
